import * as React from "react";
import { EcgTest } from "webportalclient";
import { DateTimeAccuracy, LocalizedDateTime } from "../misc/components/LocalizedDateTime";

export interface EcgResultsPanelProps {
    test: EcgTest;
    controls?: React.ReactNode;
    children?: React.ReactNode;
}

export const EcgResultsPanel = ({ test, controls, children } : EcgResultsPanelProps) => {
    return (
        <div className="panel panel-default">
            <div className="panel-body">
                <table id="ResultsTable" className="table table-striped">
                    <thead>
                        <tr>
                            <th />
                            <th>
                                Recording {test.index}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><b>Time</b></td>
                            <td key={`TestDateTime${test.id}`}>
                                <LocalizedDateTime
                                    time={test.occurred}
                                    accuracy={DateTimeAccuracy.Second}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td><b>Glasgow Summary Statement</b></td>
                            <td>{test.summaryStatement}</td>
                        </tr>
                        <tr>
                            <td><b>Glasgow Rhythm Analysis Statement</b></td>
                            <td>{test.analysisStatement}</td>
                        </tr>
                        <tr>
                            <td><b>Glasgow Diagnostic Statement</b></td>
                            <td>{test.diagnosticStatement}</td>
                        </tr>
                        <tr>
                            {controls}
                        </tr>
                    </tbody>
                </table>
                {children}
            </div>
        </div>
    );
}
